import { withSuspense } from "../../utils/withSuspense";

export const SubpageModalLazy = withSuspense(
  () => import("./subPageModal/SubPageModal")
);

export const RemovePageModalLazy = withSuspense(
  () => import("../node/toast/RemovePageModal")
);

export const AddNavItemModalLazy = withSuspense(
  () => import("./addNavItemModal/addNavItemModal")
);

export const CheckLinksModalLazy = withSuspense(
  () => import("../node/toast/checkLinksModal/CheckLinksModal")
);

export const SelectionModalLazy = withSuspense(
  () => import("./selectionModal")
);

export const PublishLimitModalLazy = withSuspense(
  () => import("./limit-modals/publish-limit-modal")
);

export const PublishSubpagesLimitModalLazy = withSuspense(
  () => import("./limit-modals/publish-subpages-limit-modal")
);

export const SubpagesLimitModalLazy = withSuspense(
  () => import("./limit-modals/subpages-limit-modal")
);

export const RemoveBrandingModalLazy = withSuspense(
  () => import("./limit-modals/remove-branding-limit")
);

export const BlocksLimitModalLazy = withSuspense(
  () => import("./limit-modals/blocks-limit-modal")
);
